export const isProd = () => process.env.NODE_ENV === 'production';
export const isDev = () => process.env.NODE_ENV === 'development';
export const isTest = () => process.env.REACT_APP_BUILD_ENV === 'test';
export const runInDev = (func: () => void) => (isDev() ? func() : null);
export const runInTest = (func: () => void) => (isTest() ? func() : null);
export const runNotInTest = (func: () => void) => (!isTest() ? func() : null);
export const runInProd = (func: () => void) => (isProd() ? func() : null);
export const isMockingEnabled = () => process.env.NEXT_PUBLIC_MOCKING_ENABLED === 'true';
